<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_filter="$_customVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_customVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesQualityInspectCommonTemplateResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_filter="$_customVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_customVuexMixin_vo"
                                      header-btn-add-disabled
                                      with-custom-row-actions-first-column
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            type="process"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="新增"
                                            custom-icon="fa fa-clone"
                                            :busy="loading"
                                            @click="copyOne(row)"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-12-10 11:19:54

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import customVuexNameMixin from "@/mixin/em/common/stuffs/customVuex/customVuexNameMixin";

export default {
    name: "sithMesQualityInspectCommonTemplateListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, customVuexNameMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        customVuexName() {
            return this.$store.state.routeStore.content['templateCustomVuexName'];
        },
        resultId() {
            return this.$store.state.routeStore.content['templateResultId'];
        }
    },
    data() {
        return {
            loading: false
        }
    },
    mounted() {
        if (this.resultId) {
            this.insertHolder('resultId', this.resultId);
        }
    },
    methods: {
        copyOne(row) {
            this.loading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_QUALITY_URL + "/sithMesQualityInspectCommonTemplate/copyOne?id=" + row.id
            }).then(() => {
                this.$refs.emListFilter.doQuery();
            }).finally(() => {
                this.loading = false;
            })
        }
    }
};
</script>